<template>
  <div>
    <h2>404</h2>
    <h3>Page Not Found</h3>
    <empty-state
      v-bind:callToAction="callToAction"
      v-bind:image="emptyStateImage"
      v-bind:description="emptyStateDescription"
      v-bind:act="openNewListModal"
      v-bind:primary="true"
    ></empty-state>
  </div>
</template>

<script>
import EmptyState from "../EmptyState";

export default {
  components: {
    EmptyState
  },
  data() {
    return {
      pageTitle: "Lists",
      callToAction: "Create new session",
      emptyStateDescription:
        "Oops! This page doesn't exist... yet.",
      emptyStateImage: "undraw_not_found.svg"
    };
  }
};
</script>

<style scoped lang="scss">
@use '../../styles/theme';

h2, h3 {
  text-align: center;
}

h2 {
  font-size: 34px !important;
  margin-top: 40px;
}

</style>